<template>
  <MglMarker
    ref="marker"
    :coordinates="coordinates"
    :draggable="isDraggable"
    :offset="[-12, -35]"
    @dragend="dragEnd"
  >
    <template slot="marker">
      <MarkerUI
        :point="point"
        :is-selected="isSelected"
        :has-edit-permission="hasEditPermission"
      />
    </template>
  </MglMarker>
</template>

<script>
import { MglMarker } from 'vue-mapbox'
import MarkerUI from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/mapbox/MarkerUI'
import markerIsSelected from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/mapbox/markerIsSelected'
import { actions, getters } from '@/vuex/modules/pointGroupOperation/constants'
import RouteHelper from '@/mixins/RouteHelper'
import cloneDeep from 'lodash/cloneDeep'
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

export default {
  components: {
    MglMarker,
    MarkerUI,
  },
  mixins: [RouteHelper],
  props: {
    point: Object,
    hasEditPermission: Boolean,
  },
  computed: {
    coordinates() {
      const point = this.point
      return [point.shape.longitude, point.shape.latitude]
    },
    color() {
      const point = this.point
      if (point.newItem.new) {
        return '#FF0F0F'
      }

      if (point.updated) {
        return '#FF8000'
      }

      if (point.status === 'active') {
        return '#448aff'
      } else {
        return '#999999'
      }
    },
    isSelected() {
      const point = this.point
      if (!('id' in point)) return false

      const selectedPoint = this.$store.getters[getters.selectedPoint]

      return markerIsSelected({ thisPoint: point, selectedPoint })
    },
    targetGroupType() {
      return this.$store.getters[getters.targetGroup].locationType
    },
    isEditingPoiCategory() {
      return this.$store.getters[getters.isEditingPoiCategory]
    },
    isDraggable() {
      if (this.underSystemOwnerPage) return false
      if (!this.hasEditPermission) return false
      if (this.isEditingPoiCategory) return false
      return this.targetGroupType !== locationGroupType.POI_LOCATION
    },
  },
  mounted() {
    this.checkSelected()
  },
  updated() {
    this.checkSelected()
  },
  methods: {
    dragEnd(e) {
      this.$store.dispatch(actions.SET_LAST_DRAG_END_TIME)
      const { lng, lat } = e.marker.getLngLat()
      const point = cloneDeep(this.point)
      point.shape.longitude = lng
      point.shape.latitude = lat
      this.$store.dispatch(actions.EDIT_GROUP_POINT, { data: point })
      this.$store.dispatch(actions.SET_SELECTED_POINT, {
        data: this.point,
        moveMap: false,
      })
    },
    // ポップアップ中なら重なり順を最前列に持ってくる
    checkSelected() {
      const dom = this.$refs.marker.marker._element
      if (this.isSelected) {
        dom.classList.add('active')
      } else {
        dom.classList.remove('active')
      }
    },
  },
}
</script>

<style scoped>
.active {
  z-index: 1;
}
</style>
